module.exports = __webpack_public_path__ + "static/testi-1-5-9a4e111cf39d141655ff05c8ad2d5874.jpg";